define('lq/events/actions/asyncEventReceiver',[
    'lq/events/actions/eventAction',
    'lq/asyncSubcriptions'
], function (EventAction, asyncSubcriptions) {
    'use strict';
        
    function AsyncEventReceiver(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(AsyncEventReceiver, EventAction);

    AsyncEventReceiver.typeName = 'AsyncEventReceiver';

    AsyncEventReceiver.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
        
    AsyncEventReceiver.prototype.execute = function (continuation) {
        asyncSubcriptions
            .addEventSubscription(
                this.piping,
                this.eventData.command,
                this.eventData.filter,
                this.receiveEvent.bind(this))
            .then(continuation);
    };

    AsyncEventReceiver.prototype.receiveEvent = function (event, argument) {
        if (this.eventData.events.indexOf(event) === -1) return;

        this.piping.eventing.publish(this.eventData.command + '.' + event, this.eventSource, argument);
    };

    return AsyncEventReceiver;
});
